import React from "react";
import RecordManager from "../../../components/founder/RecordManager";
import FilesPanel from "../../../components/founder/FilesPanel";
import { SectionCard, Empty } from "../../../components/founder/ui";

export default function HistoryTab({ ws, bid, reload }) {
  const hist = ws.status_history;
  return (
    <div className="grid gap-5 lg:grid-cols-2 max-w-5xl">
      <SectionCard title="Status History" testid="history-timeline">
        {hist.length === 0 ? <Empty>No history yet.</Empty> : (
          <ol className="relative border-l-2 border-lr-leather/20 pl-5 space-y-4">
            {hist.map((h) => (
              <li key={h.id} className="relative">
                <span className="absolute -left-[27px] top-1 h-3 w-3 rounded-full bg-lr-clay border-2 border-lr-cream" />
                <div className="text-lr-charcoal text-sm">
                  {h.from_status ? <>{h.from_status} <span className="text-lr-leather">→</span> </> : ""}<span className="font-medium">{h.to_status}</span>
                </div>
                {h.note && <div className="text-xs text-lr-leather">{h.note}</div>}
                <div className="text-[11px] text-lr-leather/70">{(h.created_at || "").slice(0, 16).replace("T", " ")}</div>
              </li>
            ))}
          </ol>
        )}
      </SectionCard>

      <div className="lr-card p-5">
        <RecordManager
          resource="follow_ups" bid={bid} items={ws.follow_ups} testid="followups-manager"
          title="Follow-ups" addLabel="Add follow-up" onChange={reload}
          fields={[
            { name: "reason", label: "Reason", type: "text" },
            { name: "due_date", label: "Due date (YYYY-MM-DD)", type: "text" },
          ]}
          renderItem={(f) => (
            <div className="flex items-center justify-between">
              <span className="text-lr-charcoal text-sm">{f.reason}</span>
              <span className={`text-xs ${f.done ? "text-lr-olive" : "text-lr-clay"}`}>{f.done ? "done" : f.due_date || "no date"}</span>
            </div>
          )}
        />
      </div>

      <div className="lr-card p-5">
        <RecordManager
          resource="notes" bid={bid} items={ws.notes} testid="notes-manager"
          title="Notes" addLabel="Add note" onChange={reload}
          fields={[{ name: "text", label: "Note", type: "textarea", rows: 3 }, { name: "area", label: "Tag (optional)", type: "text" }]}
          renderItem={(n) => (
            <div>
              {n.area && <div className="text-xs uppercase tracking-wide text-lr-clay mb-1">{n.area}</div>}
              <div className="text-sm text-lr-charcoal whitespace-pre-wrap">{n.text}</div>
            </div>
          )}
        />
      </div>

      <div className="lr-card p-5"><FilesPanel bid={bid} files={ws.files} onChange={reload} /></div>
    </div>
  );
}
